import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

// Prevent caching of API responses
api.interceptors.request.use((config) => {
  config.headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
  config.headers['Pragma'] = 'no-cache';
  return config;
});

// Add auth header for admin requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token && config.url?.includes('/ops')) {
    config.headers.Authorization = `Bearer ${token}`;
    config.params = { ...config.params, authorization: `Bearer ${token}` };
  }
  return config;
});

// Blueprint
export const createBlueprintSession = (data) => api.post('/blueprint/sessions', data);
export const getBlueprintSession = (token) => api.get(`/blueprint/sessions/${token}`);
export const updateBlueprintSession = (token, data) => api.patch(`/blueprint/sessions/${token}`, data);
export const completeBlueprintSession = (token) => api.post(`/blueprint/sessions/${token}/complete`);

// Leads
export const captureLead = (data) => api.post('/leads/capture', data);

// Content
export const getNeighbourhoods = () => api.get('/content/neighbourhoods');
export const getNeighbourhood = (slug) => api.get(`/content/neighbourhoods/${slug}`);

// Analytics
export const trackEvent = (data) => api.post('/analytics/events', data).catch(() => {});

// Admin
export const adminLogin = (data) => api.post('/ops/auth/login', data);
export const getLeads = (params) => api.get('/ops/leads', { params });
export const getLeadDetail = (id) => api.get(`/ops/leads/${id}`);
export const updateLead = (id, data) => api.patch(`/ops/leads/${id}`, data);
export const getAnalyticsSummary = () => api.get('/ops/analytics/summary');
export const getDashboardData = () => api.get('/ops/dashboard-data');
export const exportLeadsCSV = (params) => {
  const token = localStorage.getItem('admin_token');
  const queryStr = new URLSearchParams({ ...params, authorization: `Bearer ${token}` }).toString();
  window.open(`${API}/ops/leads/export?${queryStr}`, '_blank');
};
export const sendWeeklyDigest = () => api.post('/ops/digest/send');

// Drip automation
export const getDripEnrollment = (leadId) => api.get(`/drip/enrollment/${leadId}`);
export const pauseDrip = (leadId, reason) => api.post(`/drip/pause/${leadId}`, null, { params: { reason } });
export const resumeDrip = (leadId) => api.post(`/drip/resume/${leadId}`);
export const enrollDrip = (leadId) => api.post(`/drip/enroll/${leadId}`);
export const getDripAnalytics = () => api.get('/drip/analytics');
export const getDripSequence = () => api.get('/drip/sequence');
export const updateDripSequence = (data) => api.patch('/drip/sequence', data);

// Guides (public)
export const getGuides = (params) => api.get('/content/guides', { params });
export const getGuide = (slug) => api.get(`/content/guides/${slug}`);

// Guides (admin CMS)
export const adminGetGuides = (params) => api.get('/ops/guides', { params });
export const adminGetGuide = (slug) => api.get(`/ops/guides/${slug}`);
export const adminCreateGuide = (data) => api.post('/ops/guides', data);
export const adminUpdateGuide = (slug, data) => api.patch(`/ops/guides/${slug}`, data);
export const adminDeleteGuide = (slug) => api.delete(`/ops/guides/${slug}`);
export const adminGetCategories = () => api.get('/ops/guide-categories');
export const adminUpsertCategory = (data) => api.post('/ops/guide-categories', data);
export const adminDeleteCategory = (slug) => api.delete(`/ops/guide-categories/${slug}`);

// AI Content Assistant
export const aiGenerateContent = (data) => api.post('/ops/ai/generate-content', data);
export const aiGenerateSuggestions = (data) => api.post('/ops/ai/generate-suggestions', data);
export const aiImproveSection = (data) => api.post('/ops/ai/improve-section', data);
export const aiScoreContent = (data) => api.post('/ops/ai/score-content', data);
export const aiBatchGenerate = (data) => api.post('/ops/ai/batch-generate', data);
export const aiCheckDuplicates = (data) => api.post('/ops/ai/check-duplicates', data);
export const aiSuggestLinks = (data) => api.post('/ops/ai/suggest-links', data);

// Listings (DDF)
export const getListings = (params) => api.get('/listings', { params });
export const getListingDetail = (mls) => api.get(`/listings/${mls}`);
export const getListingStats = () => api.get('/listings/stats');
export const triggerDdfSync = () => api.post('/ops/ddf/sync');
export const getDdfStatus = () => api.get('/ops/ddf/status');
export const trackCreaEvent = (data) => api.post('/crea/track', data).catch(() => {});

export default api;
